module.exports = __webpack_public_path__ + "static/media/ellipsis-h.2af8ddb5.svg";